export default "__VITE_ASSET__0f0ce9fa__"